"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const InfoAlert = (_a) => {
    var { title, message } = _a, props = __rest(_a, ["title", "message"]);
    const theme = (0, material_1.useTheme)();
    const [visible, setVisible] = (0, react_1.useState)(true);
    const handleClose = () => {
        setVisible(false);
    };
    if (!visible)
        return null;
    return ((0, jsx_runtime_1.jsxs)(material_1.Alert, Object.assign({ onClose: handleClose, icon: (0, jsx_runtime_1.jsx)(InfoOutlined_1.default, { sx: { color: theme.palette.primary.main } }), severity: "info", sx: { py: 1, px: 1, backgroundColor: theme.palette.primary.light } }, props, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { mb: 1, variant: "h6", children: (0, jsx_runtime_1.jsx)("strong", { children: title }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: message })] })));
};
exports.default = InfoAlert;
